<script lang="ts">
	import Header from '$lib/components/header/Header.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { trackActivateFullscreen } from '$lib/services/tracking/googleAnalytics/fullscreen';
	import { trackLogoClick } from '$lib/services/tracking/googleAnalytics/tracking';
	import * as m from '$paraglide/messages';

	const { isMapFullscreen } = getMapLayoutContext();

	function handleFullScreenSwitch() {
		trackActivateFullscreen();

		$isMapFullscreen = true;
	}
</script>

<div class="hidden md:block w-full">
	<Header
		hasRoleBanner
		rightButton={{ icon: 'double-chevron-left', ariaLabel: m.action__close_panel() }}
		onRightButtonClick={handleFullScreenSwitch}
		onLogoClick={trackLogoClick}
	/>
</div>
